import { api } from '@/api/api';

const mapClient = {
  fromApi(client) {
    return {
      ...client,
      editing: false,
    };
  },
};
const mapTarget = mapClient;

export const exports = {
  namespaced: true,
  state: {
    fetching: false,
    clients: [],
    targets: [],
  },
  getters: {
    empty(state) {
      return state.clients.length === 0;
    },
  },
  mutations: {
    setFetching(state, fetching) {
      state.fetching = fetching;
    },
    setClients(state, clients) {
      state.clients = clients.map(mapClient.fromApi);
    },
    addClient(state, client) {
      state.clients.push(mapClient.fromApi(client));
    },
    updateClient(state, client) {
      state.clients = state.clients.map((c) =>
        c.id === client.id ? mapClient.fromApi(client) : c
      );
    },
    setTargets(state, targets) {
      state.targets = targets.map(mapTarget.fromApi);
    },
    addTarget(state, newExport) {
      state.targets.push(mapTarget.fromApi(newExport));
    },
    updateTarget(state, target) {
      state.targets = state.targets.map((t) =>
        t.id === target.id ? target : mapTarget.fromApi(t)
      );
    },
  },
  actions: {
    async fetchExports({ rootState, commit, dispatch }) {
      if (rootState.company.currentId === -1) {
        return;
      }
      commit('setFetching', true);
      await Promise.all([dispatch('fetchClients'), dispatch('fetchTargets')]);
      commit('setFetching', false);
    },
    async fetchClients({ rootState, commit }) {
      const { data } = await api.get(
        `companies/${rootState.company.currentId}/adobe_export_clients/`,
        {
          cache: {
            ignoreCache: true,
          },
        }
      );
      commit('setClients', data);
    },
    async addClient({ rootState, commit }, client) {
      const { data } = await api.post(
        `companies/${rootState.company.currentId}/adobe_export_clients/`,
        client
      );
      commit('addClient', data);
    },
    async updateClient({ rootState, commit }, client) {
      const { data } = await api.patch(
        `companies/${rootState.company.currentId}/adobe_export_clients/${client.id}/`,
        client
      );
      commit('updateClient', data);
    },
    async fetchTargets({ rootState, commit }) {
      const { data } = await api.get(
        `companies/${rootState.company.currentId}/adobe_export_targets/`,
        {
          cache: {
            ignoreCache: true,
          },
        }
      );
      commit('setTargets', data);
    },
    async addTarget({ rootState, commit }, target) {
      const { data } = await api.post(
        `companies/${rootState.company.currentId}/adobe_export_targets/`,
        target
      );
      commit('addTarget', data);
    },
    async updateTarget({ rootState, commit }, target) {
      const { data } = await api.patch(
        `companies/${rootState.company.currentId}/adobe_export_targets/${target.id}/`,
        target
      );
      commit('updateTarget', data);
    },
  },
};
